import { render } from "./IframesGalleryModal.vue?vue&type=template&id=1b2a057c&scoped=true"
import script from "./IframesGalleryModal.vue?vue&type=script&lang=js"
export * from "./IframesGalleryModal.vue?vue&type=script&lang=js"

import "./IframesGalleryModal.vue?vue&type=style&index=0&id=1b2a057c&scoped=true&lang=css"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2a057c"]])

export default __exports__